import { render, staticRenderFns } from "./MigrateToLCEmail.vue?vue&type=template&id=78704b2e&scoped=true&"
import script from "./MigrateToLCEmail.vue?vue&type=script&lang=js&"
export * from "./MigrateToLCEmail.vue?vue&type=script&lang=js&"
import style0 from "./MigrateToLCEmail.vue?vue&type=style&index=0&id=78704b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78704b2e",
  null
  
)

export default component.exports